export default __webpack_public_path__ + "static/media/20_SchererGruppe-DTM-Documentary-EschweilerPhotography_21A4577.a65297df.jpg";